import { defineStore } from 'pinia';
import { storeToRefs } from 'pinia';
import { HC } from '@/components/ueModel/js/HC';
import { Data } from '@/components/ueModel/js/Data';
import { usePageEvents } from '@/store/eventsControls/index';

export const useOverViewStore = defineStore('useOverViewStore', {
  /**
   * 存储全局状态
   * 1.必须是箭头函数: 为了在服务器端渲染的时候避免交叉请求导致数据状态污染
   * 和 TS 类型推导
   */
  state: () => {
    return {
      pageIndex: 0,
      tapIndex: null,
      viewTypeIndex: null,
      poiIndex: null,
      showNamePOI: true,
      isOpenWeather: false,
      OneKeyWeather: true,
      isOpenMeasurement: false,
      percents: 1,
      ueStatus: false,
      viewTypeData: [
        {
          name: '平视',
          camera: {},
        },
        {
          name: '鸟瞰',
          camera: {},
        },
      ],
      monitoringIndex: null,
      monitoringData: [
        {
          name: '道路',
          camera: {
            Location: {
              X: 28131.796898,
              Y: 148559.659956,
              Z: 55254.818034,
            },
            Rotation: {
              Pitch: -29.578774,
              Yaw: -90.635713,
              Roll: 0.0,
            },
          },
          Poi2DTemplates: ['摄像头'],
        },
        {
          name: '园区',
          camera: {
            Location: {
              X: 1072.767394,
              Y: 42258.521295,
              Z: 57320.926894,
            },
            Rotation: {
              Pitch: -43.576221,
              Yaw: -88.729222,
              Roll: 0.0,
            },
          },
          Poi2DTemplates: ['枪式摄像头', '球形摄像头', '鹰眼摄像头'],
        },
      ],
      // 园区漫游
      overView: {
        index: null,
        isOpen: false,
        arr: [
          {
            name: '路线1',
            id: 0,
          },
          {
            name: '路线2',
            id: 1,
          },
        ],
      },
    };
  },
  /**
   * 用来封装计算属性 有缓存功能  类似于computed
   */
  getters: {},
  /**
   * 编辑业务逻辑  类似于methods
   */
  actions: {
    // 控制组件逻辑  全局清除
    restOverview(isCameraBack = false) {
      let thisEvents = usePageEvents();
      const { eventsBtns, poiBtns } = storeToRefs(thisEvents);
      // 重置天气和白天
      if (!this.OneKeyWeather || this.isOpenWeather) {
        this.isOpenWeather = false;
        this.OneKeyWeather = true;
      }

      // 事件清除
      if (this.tapIndex !== null) {
        eventsBtns.value[this.tapIndex].end();
        this.tapIndex = null;
        //  统一处理镜头复原
        if (isCameraBack) {
          console.log('执行手动镜头返回');
          HC.CameraControl.CmdMoveCamera(Data.pageData[this.pageIndex].camera);
        }
      }

      if (this.poiIndex !== null) {
        poiBtns.value[this.poiIndex].end();
        this.poiIndex = null;
        this.showNamePOI = true;
        //  统一处理镜头复原
        if (isCameraBack) {
          console.log('执行手动镜头返回');
          HC.CameraControl.CmdMoveCamera(Data.pageData[this.pageIndex].camera);
        }
      }

      // 视角重置
      if (this.viewTypeIndex !== null) {
        this.viewTypeIndex = null;

        if (isCameraBack) {
          console.log('执行手动镜头返回');
          HC.CameraControl.CmdMoveCamera(Data.pageData[this.pageIndex].camera);
        }
      }

      if (this.overView.isOpen !== false) {
        console.log('清除巡游');
        this.overView.isOpen = false;
        HC.eventControl.CmdWander(-1);
        if (this.overView.index !== null) {
          this.overView.index = null;
        }
      }
      thisEvents = null;
      this.monitoringIndex = null;
    },
    SwitchDay() {
      console.log('一键日夜');
      if (this.ueStatus) {
        HC.weatherControl.CmdSwitchDayNight(!this.OneKeyWeather);
      }
    },
    SetDayTime(value = 13) {
      if (this.ueStatus) {
        HC.weatherControl.CmdSetDayTime(value);
      }
    },
    ControlWeather(value) {
      if (this.ueStatus) {
        HC.weatherControl.CmdControlWeather(value);
      }
    },
    changeView() {
      switch (this.viewTypeIndex) {
        case 0:
          console.log('平视');
          HC.CameraControl.CmdMoveCamera(Data.lowCamera);
          break;
        case 1:
          console.log('鸟瞰');
          HC.CameraControl.CmdMoveCamera(Data.flyCamera);
          break;
      }
    },
    changeOverview(index) {
      if (this.overView.index !== index) {
        this.overView.index = index;
        console.log('切换巡游');
        HC.eventControl.CmdWander(this.overView.index);
      }
    },
    // 切换页面
    changePage() {
      setTimeout(() => {
        HC.CameraControl.CmdMoveCamera(Data.pageData[this.pageIndex].camera);
      }, 500);
    },
  },
});
